import React, { memo } from "react";
import { Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { AccessTime } from "@mui/icons-material";

const SOURCE_LABELS = {
  auto: "Auto (respeita tipo de horario da empresa)",
  queue: "Fila do ticket",
  connection: "Conexao",
  company: "Empresa",
};

const BusinessHoursNode = memo(({ id, data, isConnectable, selected }) => {
  const source = data?.source || "auto";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<AccessTime />}
      title="Horario de Atendimento"
      color="#1a237e"
      bgColor="#E8EAF6"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
      handles={[
        { id: "a", type: "source", position: Position.Right, style: { top: "60%" } },
        { id: "b", type: "source", position: Position.Right, style: { top: "85%" } },
      ]}
    >
      <div style={{ fontSize: 10, color: "#5C6BC0", marginBottom: 4 }}>
        {SOURCE_LABELS[source] || SOURCE_LABELS.auto}
      </div>
      <div style={{ fontSize: 9, color: "#9e9e9e" }}>
        Inclui verificacao de feriados
      </div>

      {/* Labels das saidas */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            ABERTO
          </span>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: 4 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#ef5350", borderRadius: 4,
            padding: "2px 10px", letterSpacing: "0.04em",
          }}>
            FECHADO
          </span>
        </div>
      </div>
    </NodeWrapper>
  );
});

BusinessHoursNode.displayName = "BusinessHoursNode";
export default BusinessHoursNode;
